'use strict';

exports.__esModule = true;
exports.createPhasesCollection = createPhasesCollection;
exports.calcPhaseDuration = calcPhaseDuration;
exports.loadingPhasePrefixed = loadingPhasePrefixed;

var _performance = require('../../performance/performance');

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPhasesCollection(phasesOfApp) {
  var phases = {};

  for (var _iterator = phasesOfApp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var phase = _ref;

    deleteIndexFrom(phase);
    phases = Object.assign(phases, phase);
  }

  return phases;
}

function calcPhaseDuration(phaseStartTime) {
  return Math.floor(_performance2.default.now() - phaseStartTime);
}

function loadingPhasePrefixed(name, index) {
  return ('0' + index).slice(-2) + '_' + name;
}

function deleteIndexFrom(phase) {
  delete phase[Object.getOwnPropertyNames(phase)[0]].index;
}